<div class="popupu_card ci_popup_card pop_active_card" id="divPlanMoveCalendarPopup" *ngIf="show">

  <div class="popup_inner">

      <a href="javascript:void(0)"  (click)="planmoveReasonCancel()" class="pc_close_btn"><i class="icon-close"></i></a>

      <div class="ci_popup_txt_area">

          <p class="cpta_img cpi_sm"><img src="assets/images/move_icon.svg" alt=""></p>

          <h2>Move To</h2>

          <div class="mdc_date_tbox">

            <div class="lcta_tbox"  id="div_m_date" [ngClass]="{'error': this.state?.fromDate?.iserr}">                
                <mat-form-field>
                    <input matInput   [min]="this.minDate" [max]="this.maxDate" [ngxMatDatetimePicker]="picker_ind"
                    (dateChange)="FromdateChange1();this.state.fromDate.iserr=false"
                    placeholder="Selse Date & Time" [(ngModel)]="this.state.fromDate.value" (click)="Callopen_cal(picker_ind)">
                    <mat-datepicker-toggle matSuffix [for]="$any(picker_ind)"></mat-datepicker-toggle>
                    <ngx-mat-datetime-picker #picker_ind [showSpinners]="true" ></ngx-mat-datetime-picker>
                </mat-form-field>
                <span class="error_txt">{{this.state.fromDate.err_txt}}</span>
            </div>
  
              <div class="lcta_tbox"  [ngClass]="{'error': this.state.movereason.iserr}">
                      
                  <div class="lct_slt">
  
                      <select [(ngModel)]=this.state.movereason.value id="drpmovereasonreason" (click)="drpmovereason_Click()">
  
                          <option value="0">Select reason</option>
                          <ng-container *ngFor="let obj of this.movereasonList">
                          
                          <option value="{{obj.reason_id}}">{{obj.reason}}</option>
                          
                          </ng-container>
  
                      </select>               
              
              
                  </div>
  
              
                  <span class="error_txt">{{this.state.movereason.err_txt}}</span>
  
              </div>
  
              <div class="textarea_card" [ngClass]="{'error': this.state.movereasonComments.iserr}">
  
                  <textarea name="" [(ngModel)]=this.state.movereasonComments.value placeholder="Reason"  cols="30" rows="10" ></textarea>
                  <span class="error_txt">{{this.state.movereasonComments.err_txt}}</span>
              </div>
                  
          </div>
          
      </div>

      <div class="ci_popup_btn_area">

          <button (click)="planmoveReasonCancel()">CANCEL</button>

          <button (click)="planMoveReasonYes()">SUBMIT</button>

      </div>

  </div>

</div> 